@if (parsedSockets.length > 0) {
  <div class="sockets-container" [style]="socketsContainerStyle">
    @if (socketsLinked) {
      @for (link of socketLinks; track $index) {
        <div class="socket-link" [style]="socketLinkStyles[$index]"></div>
      }
    }
    @for (socket of parsedSockets; track $index) {
      <div class="socket" [style]="socketStyles[$index]"></div>
    }
  </div>
}
